import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  GetActivismNotifiedHoldingsToolList,
  getDefaultNotifiedHoldingsFilters,
} from '../../utils/toolsNotifiedHoldings-utils';
import { TokenDecode } from '../../utils/general-util';

export const ActivismNotifiedHoldingsToolListReq = createAsyncThunk(
  'ActivismNotifiedHoldingsToolListReq',
  async (req) => {
    const response = await GetActivismNotifiedHoldingsToolList(req);
    if (response === null) return null; // aborted by a newer search
    if (!response) return false;
    return { response };
  },
);

export const getTokenDecode = createAsyncThunk('getTokenDecodeHoldingsDataAndAnalytics', async () => {
  const response = await TokenDecode();
  return response;
});

const NotifiedHoldingsToolSlice = createSlice({
  name: 'notifiedHoldingsTool',
  initialState: {
    isLoadingNotifiedHoldingsTool: true,
    notifiedHoldingsData: [],
    notifiedHoldingsDataHeading: {},
    getTokenDecode: [],
    allowDownload: false,
    filters: getDefaultNotifiedHoldingsFilters(),
    maxRows: null,
    totalRows: null,
  },
  reducers: {
    handleResetNotifiedHoldingsTool: {
      reducer(state) {
        state.isLoadingNotifiedHoldingsTool = true;
        state.notifiedHoldingsData = [];
        state.notifiedHoldingsDataHeading = {};
        state.getTokenDecode = [];
        state.allowDownload = false;
        state.filters = getDefaultNotifiedHoldingsFilters();
        state.maxRows = null;
        state.totalRows = null;
      },
      prepare() {
        return {
          payload: {},
        };
      },
    },
    handleNotifiedHoldingsFilterChange(state, action) {
      state.filters[action.payload.key] = action.payload.value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(ActivismNotifiedHoldingsToolListReq.pending, (state) => {
        state.isLoadingNotifiedHoldingsTool = true;
      })
      .addCase(ActivismNotifiedHoldingsToolListReq.fulfilled, (state, action) => {
        if (action.payload === null) return;
        if (action.payload) {
          const { response } = action.payload;
          state.notifiedHoldingsData = response.data ?? [];
          state.notifiedHoldingsDataHeading = response.dataHeading ?? {};
          state.maxRows = response.maxRows ?? null;
          state.totalRows = response.totalRows ?? null;
        }
        state.isLoadingNotifiedHoldingsTool = false;
      })
      .addCase(getTokenDecode.fulfilled, (state, action) => {
        if (action.payload) {
          state.getTokenDecode = action.payload !== undefined ? action.payload : [];
        }
      });
  },
});

export const { handleResetNotifiedHoldingsTool, handleNotifiedHoldingsFilterChange } =
  NotifiedHoldingsToolSlice.actions;

export default NotifiedHoldingsToolSlice.reducer;
